import React from 'react';
import { Toaster } from 'react-hot-toast';
import { Analytics } from '@vercel/analytics/dist/react';
import Home from './pages/Home';

const App = () => {
  return (
    <>
      <Toaster position="top-right" />
      <Home />
      <Analytics />
    </>
  );
};

export default App;
 